<template>
  <b-card class="h-100">
    <b-card-title class="mb-0">
      {{ $t(title) }}
    </b-card-title>
    <vue-apex-charts
      type="donut"
      :options="chartOptions"
      :series="series"
    />
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    BCard,
    BCardTitle,
    VueApexCharts,
  },
  directives: {
    Ripple,
  },
  props: {
    userCount: {
      type: Object,
      required: true,
    },
    filter: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: 'Count Users',
    },
    colorStart: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      series: this.getSeries(),
      chartOptions: {
        legend: {
          position: 'bottom',
          fontSize: '14px',
          fontFamily: 'Montserrat',
          fontColor: false,
          labels: {
            colors: false,
          },
        },
        colors: this.getColors(),
        dataLabels: {
          enabled: true,
          formatter(val, opts) {
            return opts.w.config.series[opts.seriesIndex]
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  fontSize: '2rem',
                  fontFamily: 'Montserrat',
                },
                value: {
                  fontSize: '1rem',
                  fontFamily: 'Montserrat',
                },
                total: {
                  show: true,
                  fontSize: '1.5rem',
                  label: this.$t('Total'),
                },
              },
            },
          },
        },
        labels: this.getLabels(),
      },
    }
  },
  mounted() {
  },
  methods: {
    filterArray(obj, filter) {
      let list = {}
      if (filter) {
        Object.keys(obj).forEach(x => {
          if (filter.includes(x)) {
            list[x] = obj[x]
          }
        })
      } else {
        list = obj
      }
      return list
    },
    getLabels() {
      const list = this.filterArray(this.userCount, this.filter)
      return Object.keys(list).map(key => this.$t(`statistics.${key}`))
    },
    getSeries() {
      const list = this.filterArray(this.userCount, this.filter)
      return Object.values(list)
    },
    getColors() {
      const colors = [
        '#00d4bd',
        '#FFA1A1',
        '#2b9bf4',
        '#ffe700',
        '#60f2ca',
        '#f8d3ff',
        '#826af9',
        '#d2b0ff',
        '#992873',
      ]
      return colors.slice(this.colorStart)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
